
(function () {
  'use strict';

  let activeRoot = null;
  let activeItem = null;
  let quickViewLoading = false;

  /**
   * =========================================================
   * SHOP THE LOOK GLOBAL MODAL
   * =========================================================
   */

  function getShopLookModal() {
    return document.querySelector(
      '[data-shop-this-look-modal]'
    );
  }

  function openShopLookModal(root, item) {
    const modal = getShopLookModal();

    if (!modal) {
      console.error(
        '[Shop The Look] Global modal not found'
      );
      return;
    }

    const content = modal.querySelector(
      '[data-shop-this-look-modal-content]'
    );

    if (!content) {
      console.error(
        '[Shop The Look] Modal content not found'
      );
      return;
    }

    const data = item.querySelector(
      '[data-shop-this-look-data]'
    );

    if (!data) {
      console.error(
        '[Shop The Look] Popup data not found'
      );
      return;
    }

    activeRoot = root;
    activeItem = item;

    /**
     * Copy product cards into global popup
     */
    content.innerHTML = data.innerHTML;

    modal.hidden = false;
    modal.classList.add('is-open');

    modal.style.display = 'block';
    modal.style.visibility = 'visible';
    modal.style.opacity = '1';

    document.body.classList.add(
      'shop-this-look-open'
    );

    document.body.style.overflow = 'hidden';

    /**
     * Fix lazy images
     */
    initPopupImages(modal);

    /**
     * Init Quick Buy / Quick View
     */
    initProductCards(modal);

    console.log(
      '[Shop The Look] Shop The Look popup opened'
    );
  }

  function closeShopLookModal() {
    const modal = getShopLookModal();

    if (!modal) {
      return;
    }

    modal.classList.remove('is-open');

    modal.style.display = '';
    modal.style.visibility = '';
    modal.style.opacity = '';

    modal.hidden = true;

    document.body.classList.remove(
      'shop-this-look-open'
    );

    document.body.style.overflow = '';

    activeRoot = null;
    activeItem = null;
  }

  /**
   * =========================================================
   * IMAGE LOADING
   * =========================================================
   */

  function initPopupImages(container) {
    if (!container) {
      return;
    }

    const images =
      container.querySelectorAll('img');

    images.forEach(function (img) {
      const lazySrc =
        img.getAttribute('data-src') ||
        img.getAttribute('data-lazy-src') ||
        img.getAttribute('data-original');

      const lazySrcset =
        img.getAttribute('data-srcset') ||
        img.getAttribute('data-lazy-srcset');

      if (
        (!img.getAttribute('src') ||
          img.getAttribute('src') === '' ||
          img.getAttribute('src') === 'data:,') &&
        lazySrc
      ) {
        img.setAttribute('src', lazySrc);
      }

      if (
        (!img.getAttribute('srcset') ||
          img.getAttribute('srcset') === '') &&
        lazySrcset
      ) {
        img.setAttribute(
          'srcset',
          lazySrcset
        );
      }

      img.loading = 'eager';

      img.removeAttribute('data-src');
      img.removeAttribute('data-lazy-src');
      img.removeAttribute('data-original');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-lazy-srcset');

      img.classList.remove(
        'bls-loading-image'
      );

      img.style.opacity = '1';
      img.style.visibility = 'visible';
      img.style.display = 'block';

      const responsive =
        img.closest(
          '.bls__responsive-image'
        );

      if (responsive) {
        responsive.classList.remove(
          'bls-loading-image'
        );

        responsive.style.opacity = '1';
        responsive.style.visibility =
          'visible';
        responsive.style.display = 'block';
      }

      const mainImg =
        img.closest(
          '.bls__product-main-img'
        );

      if (mainImg) {
        mainImg.style.opacity = '1';
        mainImg.style.visibility =
          'visible';
        mainImg.style.display = 'block';
      }
    });
  }

  /**
   * =========================================================
   * PRODUCT CARDS
   * =========================================================
   */

  function initProductCards(container) {
    if (!container) {
      return;
    }

    const products =
      container.querySelectorAll(
        '[data-shop-this-look-product]'
      );

    console.log(
      '[Shop The Look] Product cards:',
      products.length
    );

    products.forEach(function (product) {
      const productCard =
        product.querySelector(
          '[data-product-handle]'
        );

      if (!productCard) {
        console.warn(
          '[Shop The Look] Product card not found'
        );
        return;
      }

      const handle =
        productCard.getAttribute(
          'data-product-handle'
        );

      console.log(
        '[Shop The Look] Product handle:',
        handle
      );

      if (!handle) {
        return;
      }

      /**
       * quick-buy is ADD TO CART in this theme.
       *
       * We intercept it and open Quick View instead.
       */
      const quickBuys =
        product.querySelectorAll(
          'quick-buy'
        );

      quickBuys.forEach(function (quickBuy) {
        if (
          quickBuy.dataset
            .shopLookQuickViewBound === 'true'
        ) {
          return;
        }

        quickBuy.dataset
          .shopLookQuickViewBound = 'true';

        quickBuy.addEventListener(
          'click',
          function (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            console.log(
              '[Shop The Look] Quick View clicked:',
              handle
            );

            openQuickView(handle);
          },
          true
        );
      });
    });
  }

  /**
   * =========================================================
   * QUICK VIEW
   * =========================================================
   */

  async function openQuickView(handle) {
    if (!handle) {
      return;
    }

    if (quickViewLoading) {
      return;
    }

    quickViewLoading = true;

    console.log(
      '[Shop The Look] Opening Quick View:',
      handle
    );

    try {
      /**
       * -----------------------------------------------------
       * Remove previous Quick View
       * -----------------------------------------------------
       */

      const oldQuickView =
        document.querySelector(
          '#dlg-product-quickview_0'
        );

      if (oldQuickView) {
        oldQuickView.remove();
      }

      /**
       * -----------------------------------------------------
       * Fetch native Shopify Quick View section
       * -----------------------------------------------------
       */

      const url =
        `/products/${encodeURIComponent(handle)}/?section_id=product-quickview`;

      console.log(
        '[Shop The Look] Quick View URL:',
        url
      );

      const response =
        await fetch(url, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With':
              'XMLHttpRequest'
          }
        });

      if (!response.ok) {
        throw new Error(
          `Quick View request failed: ${response.status}`
        );
      }

      const html =
        await response.text();

      console.log(
        '[Shop The Look] Quick View response:',
        html.length
      );

      /**
       * -----------------------------------------------------
       * Parse response
       * -----------------------------------------------------
       */

      const parser =
        new DOMParser();

      const doc =
        parser.parseFromString(
          html,
          'text/html'
        );

      /**
       * Shopify section can return:
       *
       * <div id="shopify-section-product-quickview">
       *   ...
       * </div>
       *
       * Find actual Quick View content.
       */

      let productContent =
        doc.querySelector(
          '.bls__product-quickview'
        );

      if (!productContent) {
        productContent =
          doc.querySelector(
            '[data-product-quickview]'
          );
      }

      if (!productContent) {
        productContent =
          doc.body.firstElementChild;
      }

      if (!productContent) {
        throw new Error(
          'Quick View HTML is empty'
        );
      }

      /**
       * -----------------------------------------------------
       * Create native-like dialog
       * -----------------------------------------------------
       */

      const dialog =
        document.createElement('div');

      dialog.id =
        'dlg-product-quickview_0';

      dialog.className =
        'dlg dlg-disable-heading dlg-multi dlg-disable-footer dlg-disable-drag dialog-open';

      dialog.setAttribute(
        'data-shop-look-quickview',
        ''
      );

      dialog.innerHTML = `
        <div
          id="dlg-product-quickview_0_1"
          class="dlg-box"
        >
          <span
            class="dlg-close-x icon-x"
            data-shop-look-quickview-close
          >×</span>

          <div class="dlg-message"></div>
        </div>
      `;

      const message =
        dialog.querySelector(
          '.dlg-message'
        );

      /**
       * Clone fetched content
       */
      const clonedContent =
        productContent.cloneNode(true);

      message.appendChild(
        clonedContent
      );

      document.body.appendChild(
        dialog
      );

      /**
       * -----------------------------------------------------
       * Position / visibility
       * -----------------------------------------------------
       */

      const box =
        dialog.querySelector(
          '.dlg-box'
        );

      dialog.style.display = 'block';
      dialog.style.visibility =
        'visible';
      dialog.style.opacity = '1';

      if (box) {
        box.style.visibility =
          'visible';
        box.style.opacity = '1';

        /**
         * Theme dialog normally uses fixed
         * positioning.
         */
        box.style.position =
          'relative';
      }

      document.body.classList.add(
        'dialog-open'
      );

      /**
       * -----------------------------------------------------
       * Upgrade custom elements
       * -----------------------------------------------------
       */

      upgradeQuickViewElements(
        dialog
      );

      /**
       * -----------------------------------------------------
       * Images
       * -----------------------------------------------------
       */

      initPopupImages(dialog);

      /**
       * -----------------------------------------------------
       * Swiper
       * -----------------------------------------------------
       */

      initQuickViewSwiper(dialog);

      /**
       * -----------------------------------------------------
       * Close
       * -----------------------------------------------------
       */

      initQuickViewClose(dialog);

      /**
       * -----------------------------------------------------
       * Variant elements
       * -----------------------------------------------------
       */

      initQuickViewVariant(
        dialog
      );

      console.log(
        '[Shop The Look] Quick View opened:',
        dialog
      );

    } catch (error) {
      console.error(
        '[Shop The Look] Quick View error:',
        error
      );
    } finally {
      quickViewLoading = false;
    }
  }

  /**
   * =========================================================
   * CUSTOM ELEMENTS
   * =========================================================
   */

  function upgradeQuickViewElements(
    container
  ) {
    const tags = [
      'variant-radios-quickview',
      'product-form',
      'shopify-accelerated-checkout',
      'shopify-buy-it-now-button'
    ];

    tags.forEach(function (tag) {
      container
        .querySelectorAll(tag)
        .forEach(function (element) {
          try {
            if (
              window.customElements &&
              window.customElements.upgrade
            ) {
              window.customElements.upgrade(
                element
              );
            }
          } catch (error) {
            console.warn(
              '[Shop The Look] Custom element upgrade failed:',
              tag,
              error
            );
          }
        });
    });
  }

  /**
   * =========================================================
   * QUICK VIEW VARIANT
   * =========================================================
   */

  function initQuickViewVariant(
    container
  ) {
    const variantRadios =
      container.querySelector(
        'variant-radios-quickview'
      );

    if (!variantRadios) {
      console.warn(
        '[Shop The Look] variant-radios-quickview not found'
      );
      return;
    }

    console.log(
      '[Shop The Look] variant-radios-quickview:',
      variantRadios
    );

    /**
     * Trigger change for currently checked
     * variant if necessary.
     */
    const checked =
      variantRadios.querySelector(
        'input[type="radio"]:checked'
      );

    if (checked) {
      setTimeout(function () {
        checked.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }, 50);
    }
  }

  /**
   * =========================================================
   * QUICK VIEW SWIPER
   * =========================================================
   */

  function initQuickViewSwiper(
    container
  ) {
    const swiperElement =
      container.querySelector(
        '#bls__swiper-qickview'
      );

    if (!swiperElement) {
      return;
    }

    /**
     * If theme's Swiper is already initialized
     * don't initialize twice.
     */
    if (
      swiperElement.swiper
    ) {
      console.log(
        '[Shop The Look] Swiper already initialized'
      );

      return;
    }

    /**
     * Theme may initialize it asynchronously.
     */
    setTimeout(function () {
      if (
        swiperElement.swiper
      ) {
        return;
      }

      if (
        typeof Swiper === 'undefined'
      ) {
        console.warn(
          '[Shop The Look] Swiper not available'
        );

        return;
      }

      try {
        new Swiper(
          swiperElement,
          {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
              nextEl:
                container.querySelector(
                  '.swiper-button-next'
                ),
              prevEl:
                container.querySelector(
                  '.swiper-button-prev'
                )
            },
            pagination: {
              el:
                container.querySelector(
                  '.swiper-pagination'
                ),
              clickable: true
            }
          }
        );

        console.log(
          '[Shop The Look] Swiper initialized'
        );

      } catch (error) {
        console.warn(
          '[Shop The Look] Swiper init failed:',
          error
        );
      }
    }, 100);
  }

  /**
   * =========================================================
   * QUICK VIEW CLOSE
   * =========================================================
   */

  function initQuickViewClose(
    dialog
  ) {
    const close =
      dialog.querySelector(
        '[data-shop-look-quickview-close]'
      );

    if (close) {
      close.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          closeQuickView(dialog);
        }
      );
    }

    /**
     * Click outside box
     */
    dialog.addEventListener(
      'click',
      function (event) {
        if (
          event.target === dialog
        ) {
          closeQuickView(dialog);
        }
      }
    );
  }

  function closeQuickView(
    dialog
  ) {
    if (!dialog) {
      return;
    }

    console.log(
      '[Shop The Look] Close Quick View'
    );

    dialog.classList.remove(
      'dialog-open'
    );

    dialog.remove();

    document.body.classList.remove(
      'dialog-open'
    );
  }

  /**
   * =========================================================
   * ESC
   * =========================================================
   */

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key !== 'Escape'
      ) {
        return;
      }

      /**
       * Close Quick View first
       */
      const quickView =
        document.querySelector(
          '[data-shop-look-quickview]'
        );

      if (quickView) {
        closeQuickView(
          quickView
        );

        return;
      }

      /**
       * Otherwise close Shop The Look
       */
      closeShopLookModal();
    }
  );

  /**
   * =========================================================
   * SHOP THE LOOK INIT
   * =========================================================
   */

  function initShopTheLook() {
    const roots =
      document.querySelectorAll(
        '[data-shop-this-look]'
      );

    console.log(
      '[Shop The Look] roots:',
      roots.length
    );

    roots.forEach(function (root) {
      const openButtons =
        root.querySelectorAll(
          '[data-shop-this-look-open]'
        );

      console.log(
        '[Shop The Look] open buttons:',
        openButtons.length
      );

      openButtons.forEach(
        function (button) {
          if (
            button.dataset
              .shopLookOpenBound ===
            'true'
          ) {
            return;
          }

          button.dataset
            .shopLookOpenBound = 'true';

          button.addEventListener(
            'click',
            function (event) {
              event.preventDefault();
              event.stopPropagation();

              const item =
                button.closest(
                  '[data-shop-this-look-item]'
                );

              if (!item) {
                return;
              }

              openShopLookModal(
                root,
                item
              );
            }
          );
        }
      );
    });

    initShopLookModalEvents();
  }

  /**
   * =========================================================
   * SHOP THE LOOK MODAL EVENTS
   * =========================================================
   */

  function initShopLookModalEvents() {
    const modal =
      getShopLookModal();

    if (!modal) {
      return;
    }

    const close =
      modal.querySelector(
        '[data-shop-this-look-modal-close]'
      );

    if (
      close &&
      close.dataset
        .shopLookCloseBound !==
        'true'
    ) {
      close.dataset
        .shopLookCloseBound =
        'true';

      close.addEventListener(
        'click',
        function (event) {
          event.preventDefault();

          closeShopLookModal();
        }
      );
    }

    const overlay =
      modal.querySelector(
        '[data-shop-this-look-overlay]'
      );

    if (
      overlay &&
      overlay.dataset
        .shopLookOverlayBound !==
        'true'
    ) {
      overlay.dataset
        .shopLookOverlayBound =
        'true';

      overlay.addEventListener(
        'click',
        function (event) {
          if (
            event.target ===
            overlay
          ) {
            closeShopLookModal();
          }
        }
      );
    }
  }

  /**
   * =========================================================
   * BOOT
   * =========================================================
   */

  function boot() {
    console.log(
      '[Shop The Look] boot'
    );

    initShopTheLook();

    console.log(
      '[Shop The Look] Global modal:',
      getShopLookModal()
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot
    );
  } else {
    boot();
  }

  /**
   * Shopify section reload
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      console.log(
        '[Shop The Look] Shopify section loaded'
      );

      boot();
    }
  );

})();